import type { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import routes from './routes';
import MaintenanceOverlay from './components/System/MaintenanceOverlay';
import VersionUpdateDialog from './components/System/VersionUpdateDialog';
import { useMaintenanceMode } from './hooks/useMaintenanceMode';
import { useVersionUpdate } from './hooks/useVersionUpdate';


const App: FC = () => {
  const content = useRoutes(routes);
  const { pathname } = useLocation();
  const { active: maintenanceActive, config: maintenanceConfig, ready: maintenanceReady } = useMaintenanceMode();
  const {
    updateAvailable,
    remoteVersion,
    localVersion,
    snooze,
    reloadNow,
  } = useVersionUpdate(!maintenanceActive);

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div>
        {content}
        {maintenanceReady && maintenanceActive && <MaintenanceOverlay config={maintenanceConfig} />}
        {!maintenanceActive && updateAvailable && remoteVersion && (
          <VersionUpdateDialog
            localVersion={localVersion}
            remoteVersion={remoteVersion}
            onReload={reloadNow}
            onSnooze={() => snooze(5)}
          />
        )}
    </div>
    
  );
};

export default App;
